
import _sortBy from 'lodash/sortBy';

import {
  getServiceHierarchies,
  getServiceHierarchiesAttributeValue,
} from '@homeservices/api-kit/servicecatalog/servicehierarchies';

export default {
  namespaced: true,
  state () {
    return {
      serviceHierarchies: null,
      selectedHierarchy: null,
    };
  },
  getters: {
    serviceHierarchies (state) {
      return state.serviceHierarchies && _sortBy(state.serviceHierarchies, 'rank');
    },
    selectedHierarchy (state) {
      return state.selectedHierarchy;
    },
  },
  actions: {
    async fetchHierarchies ({ commit }) {
      const { data: services } = await getServiceHierarchies({
        expand: 'services',
        depth: 1,
        namespace: 'Pro-Referral',
        lifecycleStatus: '1',
      });

      const serviceIds = services.map(service => service.id);

      const { data: { results: serviceAttributes } } = await getServiceHierarchiesAttributeValue({
        service_hierarchy_ids: serviceIds.join(','),
      });

      const iconSet = serviceAttributes.reduce((acc, attributes) => {
        if (attributes.service_hierarchy_attribute_name === 'icon') {
          const {
            service_hierarchy_id: id,
            service_hierarchy_attribute_value: icon } = attributes;
          acc[id] = icon;
        }
        return acc;
      });

      const servicesWithIcon = _sortBy(services.map((service) => {
        const item = {
          ...service,
          icon: iconSet[service.id],
        };
        return item;
      }), 'name');
      commit('setServiceHierarchies', servicesWithIcon);
    },
    reset ({ commit }) {
      commit('resetSelectedHierarchy');
    },
  },
  mutations: {
    setServiceHierarchies (state, data) {
      state.serviceHierarchies = data;
    },
    setSelectedHierarchy (state, data) {
      state.selectedHierarchy = data;
    },
    resetSelectedHierarchy (state) {
      state.selectedHierarchy = null;
    },
  },
};
